import { EventEmitter } from "../../utils";

class Manager extends EventEmitter {
  constructor(localApis) {
    super();
    this.localApis = localApis;
  }

  checkStatus() {
    return this.localApis.ping().then(({
      data
    }) => {
      this.emit("status", {
        isRunning: true,
        ...data
      });
      return data;
    }).catch(err => {
      this.emit("status", {
        isRunning: false,
        details: err
      }); // NOTE: ignore error, because LocalProvider doesn't handle it
      // "Failed to connect with MyDPD Customer App" is showed in the banner and related to the status.isRunning
    });
  }

}

export default Manager;